import { render, staticRenderFns } from "./AamsInspectionRegApproval.vue?vue&type=template&id=847bafa2&scoped=true&"
import script from "./AamsInspectionRegApproval.vue?vue&type=script&lang=js&"
export * from "./AamsInspectionRegApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847bafa2",
  null
  
)

export default component.exports